import React from "react";
import { StyledBreadcrumb } from "./styles";

const Back = ({ actualPage }) => {
  const sections = [
    {
      key: "Painel de Controle",
      content: "Painel de Controle",
      href: "/admin/",
    },
    { key: "MBA's", content: "MBA's", href: "/admin/mba/list" },
    { key: actualPage, content: actualPage, active: true },
  ];

  return <StyledBreadcrumb icon="right angle" sections={sections} />;
};

export default Back;
